import { render, staticRenderFns } from "./TenancyRentInfo.vue?vue&type=template&id=904fe80e&scoped=true&"
import script from "./TenancyRentInfo.vue?vue&type=script&lang=js&"
export * from "./TenancyRentInfo.vue?vue&type=script&lang=js&"
import style0 from "./TenancyRentInfo.vue?vue&type=style&index=0&id=904fe80e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904fe80e",
  null
  
)

export default component.exports